import { AmaService } from './ama/ama.service';
import { FocusMonitor } from '@angular/cdk/a11y';
import { DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { AfterViewInit, NgModule, Directive } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { Angular2CsvModule } from 'angular2-csv';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSmoothDnDModule } from 'ngx-smooth-dnd';
import { AppRoutingModule } from './app-routing.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { ShowComponent } from './recruiters/show/show.component';
import { DialogboxComponent } from './serveypanel/dialogbox/dialogbox.component';
import { ModalComponent } from './shared/dialog/modal/modal.component';
import { DialogService } from './shared/services/dialog-service';
import { ExcelService } from './shared/services/export-excel/export-excel.service';
import { HomeService } from './shared/services/home.service';
import { PanelListService } from './shared/services/panel-list.service';
import { ProjectDashboardService } from './shared/services/project.dashboard.service';
import { RecruiterServices } from './shared/services/recruiter.services';
import { RoleService } from './shared/services/role-service/role.service';
import { StudiesService } from './shared/services/studies.service';
import { SharedModule } from './shared/shared.module';
import { SidebarNavComponent } from './sidebar-nav/sidebar-nav.component';
import { CookieService } from 'ngx-cookie-service';
import { AngularFirestore, AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from "@angular/fire/auth";
import { environment } from 'src/environments/environment';
import { RepositoryService } from './shared/services/repository.service';
import {ReportService} from './repository/service/report.service';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { QualListComponent } from './qual/qual-list/qual-list.component';
import { AmaModule } from './ama/ama.module';
import { DialogComponent } from './ama/dialog/dialog.component';
import { VideoModalComponent } from './shared/insights/video-modal/videomodal';
import { VideoModalNewComponent } from './shared/insights/video-modal-new/videomodal';
import { VocIntroComponent } from './shared/insights/voc-intro-screen/voc-intro';
import { DeletePopComponent } from './shared/insights/voc-delete/delete-pop';
import { RepoApiService } from './repository/service/repo-api.service';
import { ExcelViewerService } from './repository/service/excel-viewer.service';
import { MobileLoginPageComponent } from '../app/mobile-login-page/mobile-login-page.component';
import { SurveyDialogBoxComponent } from './study-survey/survey-dialog-box/survey-dialog-box.component';
import { MrsiModule } from './mrsi/mrsi.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './core/material.module';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RepositoryModule } from './repository/repository.module';
import { RepositoryHomeComponent } from './repository/repository-home/repository-home.component';
import { CallRecordingModalComponent } from './repository/call-recording-modal/call-recording-modal.component';
import { FileViewComponent } from './file-view/file-view.component';
import { QualModule } from './qual/qual.module';
import { ToplineModule } from './topline/topline.module';
import { InsightsService } from './shared/insights/service/insights.service';
import { TermandcondComponent } from './termandcond/termandcond.component';
import { QAReportDashboardModule } from './qa-report-dashboard/qa-report-dashboard.module';
import { TrinityModule } from './trinity/trinity.module';
import { ExpressModule } from './express/express.module';
import { ContractModule } from './contract/contract.module';
import * as CryptoJS from 'crypto-js';
const secret = "vP~TG--T=ChH*GJ%M7f)?gb]BjY9sd3MYyTn_3W_MZCit>7.FG9y>@c:7928Mjz0";
const firebaseConfig = {
  ...environment.firebase,
  apiKey: CryptoJS.AES.decrypt(environment.firebase.apiKey, secret).toString(CryptoJS.enc.Utf8)
};
const trackerFirebaseConfig = {
  ...environment.trackerFirebase,
  apiKey: CryptoJS.AES.decrypt(environment.trackerFirebase.apiKey, secret).toString(CryptoJS.enc.Utf8)
};
import { ClientMasterModule } from './client-master/client-master.module';
import { UserLoginComponent } from './user-login/user-login.component';
import { HomeModule } from './home/home.module';
import { HomeDashboardComponent } from './home-dashboard/home-dashboard.component';
import {SupersetDashboardModule} from './superset-dashboard/superset-dashboard.module';



const customNotifierOptions: NotifierOptions = {
  position: {
		horizontal: {
			position: 'right',
			distance: 12
		},
		vertical: {
			position: 'bottom',
			distance: 12,
			gap: 10
		}
	},
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 1
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

// @Directive()
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SidebarNavComponent,
    ShowComponent,
    ModalComponent,
    DialogboxComponent,
    QualListComponent,
    MobileLoginPageComponent,
    SurveyDialogBoxComponent,
    RepositoryHomeComponent,
    CallRecordingModalComponent,
    FileViewComponent,
    TermandcondComponent,
    UserLoginComponent,
    HomeDashboardComponent,
   ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    HttpClientModule,
    InfiniteScrollModule,
    SharedModule,
    // ChartModule,
    // AngularFireModule.initializeApp(environment.firebase),
    // AngularFireModule.initializeApp(environment.trackerFirebase),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireModule.initializeApp(trackerFirebaseConfig),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    Angular2CsvModule,
    MatDialogModule,
    MatIconModule,
    DragDropModule,
    MatSelectModule,
    MatInputModule,
    NotifierModule.withConfig(customNotifierOptions),
    NgxSmoothDnDModule,
    AmaModule,
    MrsiModule,
    RepositoryModule,
    QualModule,
    ToplineModule,
    QAReportDashboardModule,
    TrinityModule,
    ExpressModule,
    ContractModule,
    ClientMasterModule,
    SupersetDashboardModule,
    HomeModule
  ],
  providers: [
    ProjectDashboardService, 
    RecruiterServices, 
    StudiesService, 
    PanelListService, 
    ExcelService,
    CookieService,
    DialogService,
    AngularFirestore,
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    HomeService,
    RoleService,
    RepositoryService,
    ReportService,
    InsightsService,
    AmaService,
    RepoApiService,
    ExcelViewerService,
    DecimalPipe,
  ],
    exports: [ DialogboxComponent,ModalComponent ],
    entryComponents: [
      DialogboxComponent, 
      ModalComponent, 
      DialogComponent,
      VideoModalComponent,
      VocIntroComponent,
      DeletePopComponent,
      VideoModalNewComponent,
      SurveyDialogBoxComponent,
    ],
  bootstrap: [AppComponent]
})
export class AppModule implements AfterViewInit{
  constructor( private _focusMonitor: FocusMonitor){}

  ngAfterViewInit() {
    this._focusMonitor.stopMonitoring(document.getElementById('closeBtn'));
  }
}
